var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "header-search",
      class: { show: _vm.show },
      attrs: { id: "header-search" },
    },
    [
      _c("svg-icon", {
        staticClass: "search-icon",
        attrs: { name: "search" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.click.apply(null, arguments)
          },
        },
      }),
      _c(
        "el-select",
        {
          ref: "headerSearchSelect",
          staticClass: "header-search-select",
          attrs: {
            "remote-method": _vm.querySearch,
            filterable: "",
            "default-first-option": "",
            remote: "",
            placeholder: "Search",
          },
          on: { change: _vm.change },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.path,
            attrs: { value: item, label: item.meta.title.join(" > ") },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }